// Traduções do módulo de Viagens em três abas (29/09/2026): abas, detalhamento,
// lápis, apontamento de serviço, Dashboard e Relatório de Alertas. Coletadas por glob
// em core/i18n/messages.ts, ao lado das de ViagensPage.i18n.ts.
export default {
  pt: {
    'viagens.aba.dashboard': 'Dashboard',
    'viagens.aba.viagens': 'Viagens',
    'viagens.aba.alertas': 'Relatório de Alertas',
    'viagens.aba.tempoUbs': 'Tempo de UBS',
    'viagens.tempoUbs.count_one': '{{count}} viagem acima do limite',
    'viagens.tempoUbs.count_other': '{{count}} viagens acima do limite',
    'viagens.tempoUbs.hint': 'Descarga da entrada em Descarregando ao Disponível, comparada com o limite do cliente. Clique na linha para abrir a viagem.',
    'viagens.tempoUbs.vazio': 'Nenhuma viagem passou do limite de descarga do cliente no período',
    'viagens.tempoUbs.filtro.status': 'Status da cobrança',
    'viagens.tempoUbs.status.nao_cobrado': 'Não cobrado',
    'viagens.tempoUbs.status.cobrado': 'Cobrado',
    'viagens.tempoUbs.cobranca.salva.nao_cobrado': 'Viagem marcada como Não cobrado',
    'viagens.tempoUbs.cobranca.salva.cobrado': 'Viagem marcada como Cobrado',
    'viagens.tempoUbs.historico.linha': 'em {{quando}} por {{quem}}',
    'viagens.tempoUbs.historico.alguem': 'alguém',
    'viagens.tempoUbs.grupo.descarga': 'Descarga',
    'viagens.tempoUbs.grupo.tempo': 'Tempo',
    'viagens.tempoUbs.grupo.cobranca': 'Cobrança',
    'viagens.tempoUbs.col.data': 'Data',
    'viagens.tempoUbs.col.cliente': 'Cliente',
    'viagens.tempoUbs.col.contrato': 'Contrato',
    'viagens.tempoUbs.col.viagem': 'Filial e viagem',
    'viagens.tempoUbs.col.sml': 'SML',
    'viagens.tempoUbs.col.motorista': 'Motorista',
    'viagens.tempoUbs.col.placa': 'Placa',
    'viagens.tempoUbs.col.carreta': 'Carreta',
    'viagens.tempoUbs.col.inicio': 'Início',
    'viagens.tempoUbs.col.disponivel': 'Disponível em',
    'viagens.tempoUbs.col.total': 'Total',
    'viagens.tempoUbs.col.limite': 'Limite',
    'viagens.tempoUbs.col.excedente': 'Excedente',
    'viagens.tempoUbs.col.status': 'Status da cobrança',
    'viagens.tempoUbs.col.alteradoEm': 'Alterado em',
    'viagens.tempoUbs.col.alteradoPor': 'Alterado por',
    'viagens.tempoUbs.export.dica': 'Baixa as viagens da aba com os filtros aplicados, todas as páginas',
    'viagens.tempoUbs.export.vazio': 'Nenhuma viagem no filtro para baixar',
    'viagens.tempoUbs.limites.abrir': 'Tempo limite de descarga por cliente',
    'viagens.tempoUbs.limites.titulo': 'Tempo limite de descarga por cliente',
    'viagens.tempoUbs.limites.intro': 'A viagem entra na aba Tempo de UBS quando a descarga passa do limite do cliente dela, e o mesmo limite vale para o alerta Descarga acima do limite. Cliente sem limite não entra na aba, e o alerta dele continua em 24 horas.',
    'viagens.tempoUbs.limites.busca': 'Buscar cliente',
    'viagens.tempoUbs.limites.cliente': 'Cliente',
    'viagens.tempoUbs.limites.limite': 'Tempo limite',
    'viagens.tempoUbs.limites.nenhum': 'Nenhum cliente com esse nome',
    'viagens.tempoUbs.limites.horasDe': 'Horas do limite de {{cliente}}',
    'viagens.tempoUbs.limites.minutosDe': 'Minutos do limite de {{cliente}}',
    'viagens.tempoUbs.limites.invalido': 'Revise os campos em vermelho: o minuto vai até 59 e o limite, até 720 horas.',
    'viagens.tempoUbs.limites.salvo': 'Limites salvos',
    'viagens.tempoUbs.limites.erro': 'Não foi possível salvar os limites',
    'viagens.relatorio.hintClique': 'Clique na viagem para ver a entrada em cada status.',
    'viagens.col.contrato': 'Contrato',
    'viagens.contrato.foraDoHub': 'FORA DO HUB',
    'viagens.contrato.outrosServicos': 'OUTROS SERVIÇOS',
    'viagens.contrato.outrosServicosDica': 'Viagem lançada no módulo Outros Serviços Transporte.',
    'viagens.contrato.transporteMaquina': 'TRANSPORTE MÁQUINA',
    'viagens.contrato.transporteMaquinaDica': 'Viagem vinculada no Transporte Máquina, numa linha sem contrato e sem local de destino.',
    'viagens.contrato.cancelada': 'CANCELADA',
    'viagens.contrato.canceladaDica': 'Viagem cancelada no ERP. Ela não conta nos totais do Dashboard.',
    'viagens.contrato.erp': 'No ERP: {{contrato}}',
    'viagens.contrato.semErp': 'Sem vínculo com um contrato do HUB e sem contrato no ERP.',
    'viagens.contrato.destinoPrancha': 'Contrato destino',
    'viagens.contrato.garagem': 'Garagem de destino',
    'viagens.km.fonteViagem': 'KM Total da viagem no Protheus.',
    'viagens.km.fonteSubcontrato': 'Distância do subcontrato. O Protheus ainda não manda o KM da viagem.',
    'viagens.servico.apontado': 'Serviço apontado',
    'viagens.servico.apontar': 'Apontar serviço',
    'viagens.servico.trocarApontado': 'Trocar serviço apontado',
    'viagens.lapis.editar': 'Corrigir viagem',
    'viagens.lapis.ajustado': 'Corrigida por {{quem}} em {{quando}}',
    'viagens.lapis.suspenso': 'Correção suspensa: a carga ou o ciclo mudou depois dela. Vale a medida do HUB até alguém corrigir de novo.',
    'viagens.lapis.alguem': 'alguém',
    'viagens.status.adiantando': 'Adiantando',
    'viagens.status.escalado': 'Escalado',
    'viagens.status.carregando': 'Carregando',
    'viagens.status.transito': 'Trânsito',
    'viagens.status.descarregando': 'Descarregando',
    'viagens.status.disponivel': 'Disponível',
    'viagens.detalhe.titulo': 'Viagem',
    'viagens.detalhe.corrigir': 'Corrigir',
    'viagens.detalhe.status': 'Entrada em cada status',
    'viagens.detalhe.corrigido': 'Corrigido',
    'viagens.detalhe.medido': 'Medido pelo HUB: {{quando}}',
    'viagens.detalhe.semMedida': 'Sem medida do HUB',
    'viagens.detalhe.semMedidaCurta': 'Sem medida',
    'viagens.detalhe.semRegistro': 'Sem registro',
    'viagens.detalhe.descarga': 'Descarga',
    'viagens.detalhe.inicioDescarga': 'Início da descarga',
    'viagens.detalhe.fimDescarga': 'Fim da descarga',
    'viagens.detalhe.tempoDescarga': 'Tempo de descarga',
    'viagens.detalhe.tempoTransito': 'Tempo de trânsito',
    'viagens.detalhe.km': 'Quilometragem',
    'viagens.detalhe.edicoes_one': '{{count}} correção nesta viagem',
    'viagens.detalhe.edicoes_other': '{{count}} correções nesta viagem',
    'viagens.ajuste.explica': 'Corrija só o que estiver errado. A correção vale no módulo de Viagens; o Painel de Descarga e a Jornada continuam com o que a operação gravou.',
    'viagens.ajuste.travados': 'Não editáveis',
    'viagens.ajuste.medidoHub': 'Medido pelo HUB: {{quando}}',
    'viagens.ajuste.semMedidaHub': 'Sem medida do HUB',
    'viagens.ajuste.voltarAoMedido': 'Voltar ao medido',
    'viagens.ajuste.recalculo': 'Com a correção',
    'viagens.ajuste.depara': 'de {{de}} para {{para}}',
    'viagens.ajuste.nadaMudou': 'Nada mudou. Altere um campo antes de salvar.',
    'viagens.ajuste.dataInvalida': 'Data e hora inválida.',
    'viagens.ajuste.futuro': 'A data e hora não pode estar no futuro.',
    'viagens.ajuste.ordem': '{{depois}} precisa ser depois de {{antes}}.',
    'viagens.ajuste.kmInvalido': 'O quilômetro precisa ficar entre 0 e 5000 km.',
    'viagens.ajuste.salvo': 'Viagem corrigida. Tempos, otimização e alertas recalculados.',
    'viagens.apontar.titulo': 'Apontar serviço',
    'viagens.apontar.original': 'Serviço original',
    'viagens.apontar.escolha': 'Serviço correto',
    'viagens.apontar.dica': 'Os Outros Serviços do cadastro de Serviços. Não vão para o Protheus.',
    'viagens.apontar.semInternos': 'Nenhum dos Outros Serviços cadastrado ainda.',
    'viagens.apontar.remover': 'Tirar apontamento',
    'viagens.apontar.salvo': 'Serviço apontado.',
    'viagens.apontar.removido': 'Apontamento retirado.',
    'viagens.dash.viagensPorCliente': 'Viagens por cliente',
    'viagens.dash.kmTotalPorCliente': 'KM total por cliente',
    'viagens.dash.kmMedioPorCliente': 'KM médio por cliente',
    'viagens.dash.pesoTotalPorCliente': 'Peso total por cliente em Espiga',
    'viagens.dash.pesoMedioPorCliente': 'Peso médio por cliente em Espiga',
    'viagens.dash.otimizacaoEspiga': 'Otimização de KM em Espiga',
    'viagens.dash.viagensPorDiaEspiga': 'Viagens de Espiga por dia',
    'viagens.dash.viagensPorDiaHint': 'Linhas da Frente de Trabalho, pela data da carga. De baixo para cima, atendidas, em andamento nos demais status e não atendidas.',
    'viagens.dash.viagensPorDestinoEspiga': 'Viagens de Espiga por destino',
    'viagens.dash.descargaPorDestinoEspiga': 'Descarga média de Espiga por destino',
    'viagens.dash.viagensPorDupla': 'Viagens por dupla',
    'viagens.dash.viagensPorDestino': 'Viagens por destino',
    'viagens.dash.semKm': 'Nenhuma viagem com KM Protheus no recorte.',
    'viagens.dash.semPeso': 'O Protheus ainda não manda o peso das viagens.',
    'viagens.dash.tabelaPlacas': 'Por placa',
    'viagens.dash.tabelaMotoristas': 'Por motorista',
    'viagens.dash.tabelaHint': 'KM sem escala e KM vazio medidos pelo GPS, KM recebido pelo Protheus. Os serviços contam as viagens pelo serviço final. A otimização soma só as viagens que têm o vazio e o recebido. Clique no cabeçalho para ordenar.',
    'viagens.dash.col.base': 'Base',
    'viagens.dash.col.kmVazio': 'KM vazio',
    'viagens.dash.col.kmRecebido': 'KM recebido',
    'viagens.dash.col.peso': 'Peso',
    'viagens.alertas.count_one': '{{count}} alerta',
    'viagens.alertas.count_other': '{{count}} alertas',
    'viagens.alertas.hint': 'Clique na linha para abrir a viagem e corrigir pelo lápis. O alerta corrigido fecha sozinho.',
    'viagens.alertas.vazio': 'Nenhum alerta neste recorte.',
    'viagens.alertas.col.tipo': 'Tipo do alerta',
    'viagens.alertas.col.statusProtheus': 'Status no Protheus',
    'viagens.alertas.col.filial': 'Filial',
    'viagens.alertas.col.status': 'Status do alerta',
    'viagens.alertas.filtro.status': 'Status do alerta',
    'viagens.alertas.filtro.tipo': 'Tipo de alerta',
    'viagens.alertas.status.pendente': 'Pendente',
    'viagens.alertas.status.corrigido': 'Corrigido',
    'viagens.alertas.status.justificado': 'Justificado',
    'viagens.alertas.tipo.otimizacao': 'Otimização fora do limite',
    'viagens.alertas.tipo.descarga_curta': 'Descarga abaixo do limite',
    'viagens.alertas.tipo.descarga_longa': 'Descarga acima do limite',
    'viagens.alertas.tipo.transito_longo': 'Trânsito acima do esperado',
    'viagens.alertas.tipo.transito_curto': 'Trânsito abaixo do esperado',
    'viagens.alertas.tipo.km_baixo': 'KM baixo fora de Espiga',
    'viagens.alertas.regra.otimizacao': 'Otimização acima de +10% ou abaixo de −10%.',
    'viagens.alertas.regra.descarga_curta': 'Descarga com menos de 4 horas.',
    'viagens.alertas.regra.descarga_longa': 'Descarga com mais de 24 horas, o limite geral para o cliente sem limite próprio.',
    'viagens.alertas.regra.descarga_longa_cliente': 'Descarga acima do limite do cliente, de {{limite}}.',
    'viagens.alertas.regra.transito_longo': 'Trânsito acima de {{limite}}, que é 1 hora a cada 50 km do KM Protheus mais 1 hora de refeição.',
    'viagens.alertas.regra.transito_curto': 'Trânsito abaixo de {{limite}}, que é 30 minutos a cada 50 km do KM Protheus mais 1 hora de refeição.',
    'viagens.alertas.regra.km_baixo': 'Viagem que não é Espiga nem Diária com KM Protheus abaixo de 10 km.',
    'viagens.alertas.regra.semKm': 'A viagem está sem KM Protheus agora, e a faixa de trânsito não se calcula.',
    'viagens.alertas.justificar': 'Justificar',
    'viagens.alertas.editarJustificativa': 'Editar',
    'viagens.alertas.justificarTitulo': 'Justificar alerta',
    'viagens.alertas.ajudaJustificativa': 'Obrigatória. Diga por que a viagem fica como está.',
    'viagens.alertas.justificado': 'Alerta justificado',
    'viagens.alertas.quemQuando': '{{quem}}, {{quando}}',
    'viagens.alertas.corrigidoPorAjuste': 'Corrigido pelo lápis em {{quando}}',
    'viagens.alertas.corrigidoPelaMedida': 'Corrigido pela medida em {{quando}}',
    'viagens.alertas.antes': 'Antes',
    'viagens.col.kmVazioContrato': 'KM vazio contrato',
    'viagens.km.vazioContratoDica': 'O KM do cadastro do contrato. É o KM vazio esperado da viagem, comparado com o KM vazio medido pelo HUB.',
    'viagens.km.vazioContratoSem': 'Contrato sem KM no cadastro, ou viagem fora do HUB ou de Prancha.',
    'viagens.nf.dentroDaTolerancia': 'Pedida {{atraso}} depois da entrada em Trânsito, dentro do prazo de {{prazo}}.',
    'viagens.nf.foraDoPrazo': 'Pedida {{atraso}} depois da entrada em Trânsito, fora do prazo de {{prazo}}.',
    'viagens.nf.emissao.dentroDaTolerancia': 'Confirmada {{atraso}} depois da entrada em Trânsito, dentro do prazo de {{prazo}}.',
    'viagens.nf.emissao.foraDoPrazo': 'Confirmada {{atraso}} depois da entrada em Trânsito, fora do prazo de {{prazo}}.',
    'viagens.detalhe.nf': 'Solicitação de NF',
    'viagens.detalhe.nfSolicitada': 'Solicitada em',
    'viagens.detalhe.nfEmissao': 'Emissão NF',
    'viagens.detalhe.nfConfirmada': 'Confirmada em',
    'viagens.detalhe.nfAtraso': 'Depois do Trânsito',
    'viagens.ajuste.nfDepois': 'Solicitação de NF depois do Trânsito',
    'viagens.ajuste.nfEmissaoDepois': 'Emissão NF depois do Trânsito',
    'viagens.alertas.tipo.nf_atrasada': 'Solicitação de NF fora do prazo',
    'viagens.alertas.regra.nf_atrasada': 'NF solicitada mais de 30 minutos depois da entrada em Trânsito. Corrigir a entrada em Trânsito pelo lápis refaz a Solicitação de NF.',
    'viagens.dash.ind.viagens': 'Total de viagens',
    'viagens.dash.ind.viagensHint': 'Conforme os filtros',
    'viagens.dash.ind.kmTotal': 'Total de KM',
    'viagens.dash.ind.kmMedio': 'Média de KM',
    'viagens.dash.ind.kmHint': 'Espiga, pelo KM Protheus',
    'viagens.dash.ind.peso': 'Peso total transportado',
    'viagens.dash.ind.pesoMedio': 'Média de peso',
    'viagens.dash.ind.pesoHint': 'Espiga, em toneladas',
    'viagens.dash.ind.nf': 'Solicitação de NF',
    'viagens.dash.ind.nfTime': 'Time de logística',
    'viagens.dash.ind.nfEmissao': 'Emissão NF',
    'viagens.dash.ind.nfEmissaoTime': 'Time de notas',
    'viagens.dash.ind.nfEmissaoHint_one': 'Prazo de {{prazo}} da entrada em Trânsito até a confirmação. {{count}} nota medida.',
    'viagens.dash.ind.nfEmissaoHint_other': 'Prazo de {{prazo}} da entrada em Trânsito até a confirmação. {{count}} notas medidas.',
    'viagens.dash.ind.nfDentro': 'Dentro do prazo',
    'viagens.dash.ind.nfFora': 'Fora do prazo',
    'viagens.dash.ind.nfAtraso': 'Atraso médio',
    'viagens.dash.ind.nfHint_one': 'Prazo de {{prazo}} depois da entrada em Trânsito. {{count}} nota medida.',
    'viagens.dash.ind.nfHint_other': 'Prazo de {{prazo}} depois da entrada em Trânsito. {{count}} notas medidas.',
    'viagens.dash.motivos': 'Motivos do não atendimento',
    'viagens.dash.motivos.col.motivo': 'Motivo',
    'viagens.dash.motivos.col.cargas': 'Cargas',
    'viagens.dash.motivos.col.pct': 'Das não atendidas',
    'viagens.dash.motivos.vazio': 'Nenhuma carga de Espiga não atendida no recorte.',
    'viagens.dash.motivos.hint_one': '{{count}} carga de Espiga não atendida.',
    'viagens.dash.motivos.hint_other': '{{count}} cargas de Espiga não atendidas.',
    'viagens.dash.col.modalidade': 'Modalidade',
    'viagens.dash.grupo.servicos': 'Viagens por serviço',
    'viagens.dash.grupo.km': 'Quilometragem',
  },
  en: {
    'viagens.aba.dashboard': 'Dashboard',
    'viagens.aba.viagens': 'Trips',
    'viagens.aba.alertas': 'Alert Report',
    'viagens.aba.tempoUbs': 'Unloading time',
    'viagens.tempoUbs.count_one': '{{count}} trip above the limit',
    'viagens.tempoUbs.count_other': '{{count}} trips above the limit',
    'viagens.tempoUbs.hint': 'Unloading from entering Unloading until Available, compared with the customer limit. Click the row to open the trip.',
    'viagens.tempoUbs.vazio': 'No trip went over the customer unloading limit in the period',
    'viagens.tempoUbs.filtro.status': 'Billing status',
    'viagens.tempoUbs.status.nao_cobrado': 'Not billed',
    'viagens.tempoUbs.status.cobrado': 'Billed',
    'viagens.tempoUbs.cobranca.salva.nao_cobrado': 'Trip marked as Not billed',
    'viagens.tempoUbs.cobranca.salva.cobrado': 'Trip marked as Billed',
    'viagens.tempoUbs.historico.linha': 'on {{quando}} by {{quem}}',
    'viagens.tempoUbs.historico.alguem': 'someone',
    'viagens.tempoUbs.grupo.descarga': 'Unloading',
    'viagens.tempoUbs.grupo.tempo': 'Time',
    'viagens.tempoUbs.grupo.cobranca': 'Billing',
    'viagens.tempoUbs.col.data': 'Date',
    'viagens.tempoUbs.col.cliente': 'Customer',
    'viagens.tempoUbs.col.contrato': 'Contract',
    'viagens.tempoUbs.col.viagem': 'Branch and trip',
    'viagens.tempoUbs.col.sml': 'SML',
    'viagens.tempoUbs.col.motorista': 'Driver',
    'viagens.tempoUbs.col.placa': 'Plate',
    'viagens.tempoUbs.col.carreta': 'Trailer',
    'viagens.tempoUbs.col.inicio': 'Start',
    'viagens.tempoUbs.col.disponivel': 'Available at',
    'viagens.tempoUbs.col.total': 'Total',
    'viagens.tempoUbs.col.limite': 'Limit',
    'viagens.tempoUbs.col.excedente': 'Excess',
    'viagens.tempoUbs.col.status': 'Billing status',
    'viagens.tempoUbs.col.alteradoEm': 'Changed at',
    'viagens.tempoUbs.col.alteradoPor': 'Changed by',
    'viagens.tempoUbs.export.dica': 'Downloads the trips of the tab with the filters applied, every page',
    'viagens.tempoUbs.export.vazio': 'No trip in the filter to download',
    'viagens.tempoUbs.limites.abrir': 'Unloading time limit per customer',
    'viagens.tempoUbs.limites.titulo': 'Unloading time limit per customer',
    'viagens.tempoUbs.limites.intro': 'A trip enters the Unloading time tab when its unloading goes over the customer limit, and the same limit drives the Unloading over the limit alert. A customer without a limit stays out of the tab, and its alert stays at 24 hours.',
    'viagens.tempoUbs.limites.busca': 'Search customer',
    'viagens.tempoUbs.limites.cliente': 'Customer',
    'viagens.tempoUbs.limites.limite': 'Time limit',
    'viagens.tempoUbs.limites.nenhum': 'No customer with this name',
    'viagens.tempoUbs.limites.horasDe': 'Hours of the {{cliente}} limit',
    'viagens.tempoUbs.limites.minutosDe': 'Minutes of the {{cliente}} limit',
    'viagens.tempoUbs.limites.invalido': 'Check the fields in red: minutes go up to 59 and the limit up to 720 hours.',
    'viagens.tempoUbs.limites.salvo': 'Limits saved',
    'viagens.tempoUbs.limites.erro': 'Could not save the limits',
    'viagens.relatorio.hintClique': 'Click a trip to see when it entered each status.',
    'viagens.col.contrato': 'Contract',
    'viagens.contrato.foraDoHub': 'OUTSIDE THE HUB',
    'viagens.contrato.outrosServicos': 'OTHER SERVICES',
    'viagens.contrato.outrosServicosDica': 'Trip registered in the Other Transport Services module.',
    'viagens.contrato.transporteMaquina': 'MACHINE TRANSPORT',
    'viagens.contrato.transporteMaquinaDica': 'Trip linked in Machine Transport, on a line with no contract and no destination place.',
    'viagens.contrato.cancelada': 'CANCELLED',
    'viagens.contrato.canceladaDica': 'Trip cancelled in the ERP. It does not count in the Dashboard totals.',
    'viagens.contrato.erp': 'In the ERP: {{contrato}}',
    'viagens.contrato.semErp': 'No link to a HUB contract and no contract in the ERP.',
    'viagens.contrato.destinoPrancha': 'Destination contract',
    'viagens.contrato.garagem': 'Destination garage',
    'viagens.km.fonteViagem': 'Trip total KM in Protheus.',
    'viagens.km.fonteSubcontrato': 'Subcontract distance. Protheus does not send the trip KM yet.',
    'viagens.servico.apontado': 'Assigned service',
    'viagens.servico.apontar': 'Assign service',
    'viagens.servico.trocarApontado': 'Change assigned service',
    'viagens.lapis.editar': 'Correct trip',
    'viagens.lapis.ajustado': 'Corrected by {{quem}} on {{quando}}',
    'viagens.lapis.suspenso': 'Correction suspended: the load or the cycle changed after it. The HUB measurement applies until someone corrects it again.',
    'viagens.lapis.alguem': 'someone',
    'viagens.status.adiantando': 'Advancing',
    'viagens.status.escalado': 'Scheduled',
    'viagens.status.carregando': 'Loading',
    'viagens.status.transito': 'In transit',
    'viagens.status.descarregando': 'Unloading',
    'viagens.status.disponivel': 'Available',
    'viagens.detalhe.titulo': 'Trip',
    'viagens.detalhe.corrigir': 'Correct',
    'viagens.detalhe.status': 'Entry into each status',
    'viagens.detalhe.corrigido': 'Corrected',
    'viagens.detalhe.medido': 'Measured by the HUB: {{quando}}',
    'viagens.detalhe.semMedida': 'No HUB measurement',
    'viagens.detalhe.semMedidaCurta': 'No measurement',
    'viagens.detalhe.semRegistro': 'No record',
    'viagens.detalhe.descarga': 'Unloading',
    'viagens.detalhe.inicioDescarga': 'Unloading start',
    'viagens.detalhe.fimDescarga': 'Unloading end',
    'viagens.detalhe.tempoDescarga': 'Unloading time',
    'viagens.detalhe.tempoTransito': 'Transit time',
    'viagens.detalhe.km': 'Mileage',
    'viagens.detalhe.edicoes_one': '{{count}} correction on this trip',
    'viagens.detalhe.edicoes_other': '{{count}} corrections on this trip',
    'viagens.ajuste.explica': 'Correct only what is wrong. The correction applies to the Trips module; the Unloading Board and the Journey keep what operations recorded.',
    'viagens.ajuste.travados': 'Not editable',
    'viagens.ajuste.medidoHub': 'Measured by the HUB: {{quando}}',
    'viagens.ajuste.semMedidaHub': 'No HUB measurement',
    'viagens.ajuste.voltarAoMedido': 'Back to measured',
    'viagens.ajuste.recalculo': 'With the correction',
    'viagens.ajuste.depara': 'from {{de}} to {{para}}',
    'viagens.ajuste.nadaMudou': 'Nothing changed. Change a field before saving.',
    'viagens.ajuste.dataInvalida': 'Invalid date and time.',
    'viagens.ajuste.futuro': 'The date and time cannot be in the future.',
    'viagens.ajuste.ordem': '{{depois}} must be after {{antes}}.',
    'viagens.ajuste.kmInvalido': 'The kilometers must be between 0 and 5000 km.',
    'viagens.ajuste.salvo': 'Trip corrected. Times, optimization and alerts recalculated.',
    'viagens.apontar.titulo': 'Assign service',
    'viagens.apontar.original': 'Original service',
    'viagens.apontar.escolha': 'Correct service',
    'viagens.apontar.dica': 'The Other Services of the Services register. They do not go to Protheus.',
    'viagens.apontar.semInternos': 'No Other Service registered yet.',
    'viagens.apontar.remover': 'Remove assignment',
    'viagens.apontar.salvo': 'Service assigned.',
    'viagens.apontar.removido': 'Assignment removed.',
    'viagens.dash.viagensPorCliente': 'Trips by customer',
    'viagens.dash.kmTotalPorCliente': 'Total KM by customer',
    'viagens.dash.kmMedioPorCliente': 'Average KM by customer',
    'viagens.dash.pesoTotalPorCliente': 'Total weight by customer on Ear corn',
    'viagens.dash.pesoMedioPorCliente': 'Average weight by customer on Ear corn',
    'viagens.dash.otimizacaoEspiga': 'KM optimization on Ear corn',
    'viagens.dash.viagensPorDiaEspiga': 'Ear corn trips by day',
    'viagens.dash.viagensPorDiaHint': 'Work front rows, by load date. From bottom to top, fulfilled, in progress for any other status, and not fulfilled.',
    'viagens.dash.viagensPorDestinoEspiga': 'Ear corn trips by destination',
    'viagens.dash.descargaPorDestinoEspiga': 'Average Ear corn unloading by destination',
    'viagens.dash.viagensPorDupla': 'Trips by pair',
    'viagens.dash.viagensPorDestino': 'Trips by destination',
    'viagens.dash.semKm': 'No trip with Protheus KM in this range.',
    'viagens.dash.semPeso': 'Protheus does not send the trip weight yet.',
    'viagens.dash.tabelaPlacas': 'By plate',
    'viagens.dash.tabelaMotoristas': 'By driver',
    'viagens.dash.tabelaHint': 'Unscheduled and empty km measured by GPS, received km from Protheus. Services count trips by their final service. Optimization adds only trips that have empty and received km. Click a header to sort.',
    'viagens.dash.col.base': 'Base',
    'viagens.dash.col.kmVazio': 'Empty KM',
    'viagens.dash.col.kmRecebido': 'Received KM',
    'viagens.dash.col.peso': 'Weight',
    'viagens.alertas.count_one': '{{count}} alert',
    'viagens.alertas.count_other': '{{count}} alerts',
    'viagens.alertas.hint': 'Click a row to open the trip and correct it with the pencil. A corrected alert closes by itself.',
    'viagens.alertas.vazio': 'No alert in this range.',
    'viagens.alertas.col.tipo': 'Alert type',
    'viagens.alertas.col.statusProtheus': 'Status in Protheus',
    'viagens.alertas.col.filial': 'Branch',
    'viagens.alertas.col.status': 'Alert status',
    'viagens.alertas.filtro.status': 'Alert status',
    'viagens.alertas.filtro.tipo': 'Alert type',
    'viagens.alertas.status.pendente': 'Pending',
    'viagens.alertas.status.corrigido': 'Corrected',
    'viagens.alertas.status.justificado': 'Justified',
    'viagens.alertas.tipo.otimizacao': 'Optimization out of range',
    'viagens.alertas.tipo.descarga_curta': 'Unloading below the limit',
    'viagens.alertas.tipo.descarga_longa': 'Unloading above the limit',
    'viagens.alertas.tipo.transito_longo': 'Transit above expected',
    'viagens.alertas.tipo.transito_curto': 'Transit below expected',
    'viagens.alertas.tipo.km_baixo': 'Low KM outside Ear corn',
    'viagens.alertas.regra.otimizacao': 'Optimization above +10% or below −10%.',
    'viagens.alertas.regra.descarga_curta': 'Unloading under 4 hours.',
    'viagens.alertas.regra.descarga_longa': 'Unloading over 24 hours, the general limit for a customer without its own.',
    'viagens.alertas.regra.descarga_longa_cliente': 'Unloading over the customer limit of {{limite}}.',
    'viagens.alertas.regra.transito_longo': 'Transit above {{limite}}, which is 1 hour for every 50 km of Protheus KM plus 1 hour for a meal.',
    'viagens.alertas.regra.transito_curto': 'Transit below {{limite}}, which is 30 minutes for every 50 km of Protheus KM plus 1 hour for a meal.',
    'viagens.alertas.regra.km_baixo': 'Trip that is neither Ear corn nor Daily allowance with Protheus KM below 10 km.',
    'viagens.alertas.regra.semKm': 'The trip has no Protheus KM now, so the transit range cannot be calculated.',
    'viagens.alertas.justificar': 'Justify',
    'viagens.alertas.editarJustificativa': 'Edit',
    'viagens.alertas.justificarTitulo': 'Justify alert',
    'viagens.alertas.ajudaJustificativa': 'Required. Say why the trip stays as it is.',
    'viagens.alertas.justificado': 'Alert justified',
    'viagens.alertas.quemQuando': '{{quem}}, {{quando}}',
    'viagens.alertas.corrigidoPorAjuste': 'Corrected with the pencil on {{quando}}',
    'viagens.alertas.corrigidoPelaMedida': 'Corrected by the measurement on {{quando}}',
    'viagens.alertas.antes': 'Before',
    'viagens.col.kmVazioContrato': 'Contract empty km',
    'viagens.km.vazioContratoDica': 'The km in the contract record. It is the expected empty km of the trip, compared with the empty km measured by the HUB.',
    'viagens.km.vazioContratoSem': 'Contract without km in the record, or trip outside the HUB or a flatbed trip.',
    'viagens.nf.dentroDaTolerancia': 'Requested {{atraso}} after entering transit, within the {{prazo}} deadline.',
    'viagens.nf.foraDoPrazo': 'Requested {{atraso}} after entering transit, past the {{prazo}} deadline.',
    'viagens.nf.emissao.dentroDaTolerancia': 'Confirmed {{atraso}} after entering transit, within the {{prazo}} deadline.',
    'viagens.nf.emissao.foraDoPrazo': 'Confirmed {{atraso}} after entering transit, past the {{prazo}} deadline.',
    'viagens.detalhe.nf': 'Invoice request',
    'viagens.detalhe.nfSolicitada': 'Requested at',
    'viagens.detalhe.nfEmissao': 'Invoice issue',
    'viagens.detalhe.nfConfirmada': 'Confirmed at',
    'viagens.detalhe.nfAtraso': 'After transit',
    'viagens.ajuste.nfDepois': 'Invoice request after transit',
    'viagens.ajuste.nfEmissaoDepois': 'Invoice issue after transit',
    'viagens.alertas.tipo.nf_atrasada': 'Invoice request past deadline',
    'viagens.alertas.regra.nf_atrasada': 'Invoice requested more than 30 minutes after entering transit. Correcting the transit entry with the pencil recalculates the invoice request.',
    'viagens.dash.ind.viagens': 'Total trips',
    'viagens.dash.ind.viagensHint': 'According to the filters',
    'viagens.dash.ind.kmTotal': 'Total km',
    'viagens.dash.ind.kmMedio': 'Average km',
    'viagens.dash.ind.kmHint': 'Ear corn, by Protheus km',
    'viagens.dash.ind.peso': 'Total weight carried',
    'viagens.dash.ind.pesoMedio': 'Average weight',
    'viagens.dash.ind.pesoHint': 'Ear corn, in tonnes',
    'viagens.dash.ind.nf': 'Invoice request',
    'viagens.dash.ind.nfTime': 'Logistics team',
    'viagens.dash.ind.nfEmissao': 'Invoice issue',
    'viagens.dash.ind.nfEmissaoTime': 'Invoicing team',
    'viagens.dash.ind.nfEmissaoHint_one': '{{prazo}} deadline from entering transit to confirmation. {{count}} invoice measured.',
    'viagens.dash.ind.nfEmissaoHint_other': '{{prazo}} deadline from entering transit to confirmation. {{count}} invoices measured.',
    'viagens.dash.ind.nfDentro': 'On time',
    'viagens.dash.ind.nfFora': 'Late',
    'viagens.dash.ind.nfAtraso': 'Average delay',
    'viagens.dash.ind.nfHint_one': 'Deadline of {{prazo}} after entering transit. {{count}} invoice measured.',
    'viagens.dash.ind.nfHint_other': 'Deadline of {{prazo}} after entering transit. {{count}} invoices measured.',
    'viagens.dash.motivos': 'Reasons for not served',
    'viagens.dash.motivos.col.motivo': 'Reason',
    'viagens.dash.motivos.col.cargas': 'Loads',
    'viagens.dash.motivos.col.pct': 'Of not served',
    'viagens.dash.motivos.vazio': 'No ear corn load left unserved in this range.',
    'viagens.dash.motivos.hint_one': '{{count}} ear corn load not served.',
    'viagens.dash.motivos.hint_other': '{{count}} ear corn loads not served.',
    'viagens.dash.col.modalidade': 'Type',
    'viagens.dash.grupo.servicos': 'Trips by service',
    'viagens.dash.grupo.km': 'Mileage',
  },
  es: {
    'viagens.aba.dashboard': 'Dashboard',
    'viagens.aba.viagens': 'Viajes',
    'viagens.aba.alertas': 'Informe de Alertas',
    'viagens.aba.tempoUbs': 'Tiempo de UBS',
    'viagens.tempoUbs.count_one': '{{count}} viaje por encima del límite',
    'viagens.tempoUbs.count_other': '{{count}} viajes por encima del límite',
    'viagens.tempoUbs.hint': 'Descarga desde la entrada en Descargando hasta Disponible, comparada con el límite del cliente. Haga clic en la fila para abrir el viaje.',
    'viagens.tempoUbs.vazio': 'Ningún viaje superó el límite de descarga del cliente en el período',
    'viagens.tempoUbs.filtro.status': 'Estado del cobro',
    'viagens.tempoUbs.status.nao_cobrado': 'No cobrado',
    'viagens.tempoUbs.status.cobrado': 'Cobrado',
    'viagens.tempoUbs.cobranca.salva.nao_cobrado': 'Viaje marcado como No cobrado',
    'viagens.tempoUbs.cobranca.salva.cobrado': 'Viaje marcado como Cobrado',
    'viagens.tempoUbs.historico.linha': 'el {{quando}} por {{quem}}',
    'viagens.tempoUbs.historico.alguem': 'alguien',
    'viagens.tempoUbs.grupo.descarga': 'Descarga',
    'viagens.tempoUbs.grupo.tempo': 'Tiempo',
    'viagens.tempoUbs.grupo.cobranca': 'Cobro',
    'viagens.tempoUbs.col.data': 'Fecha',
    'viagens.tempoUbs.col.cliente': 'Cliente',
    'viagens.tempoUbs.col.contrato': 'Contrato',
    'viagens.tempoUbs.col.viagem': 'Filial y viaje',
    'viagens.tempoUbs.col.sml': 'SML',
    'viagens.tempoUbs.col.motorista': 'Conductor',
    'viagens.tempoUbs.col.placa': 'Placa',
    'viagens.tempoUbs.col.carreta': 'Remolque',
    'viagens.tempoUbs.col.inicio': 'Inicio',
    'viagens.tempoUbs.col.disponivel': 'Disponible el',
    'viagens.tempoUbs.col.total': 'Total',
    'viagens.tempoUbs.col.limite': 'Límite',
    'viagens.tempoUbs.col.excedente': 'Excedente',
    'viagens.tempoUbs.col.status': 'Estado del cobro',
    'viagens.tempoUbs.col.alteradoEm': 'Cambiado el',
    'viagens.tempoUbs.col.alteradoPor': 'Cambiado por',
    'viagens.tempoUbs.export.dica': 'Descarga los viajes de la pestaña con los filtros aplicados, todas las páginas',
    'viagens.tempoUbs.export.vazio': 'Ningún viaje en el filtro para descargar',
    'viagens.tempoUbs.limites.abrir': 'Tiempo límite de descarga por cliente',
    'viagens.tempoUbs.limites.titulo': 'Tiempo límite de descarga por cliente',
    'viagens.tempoUbs.limites.intro': 'El viaje entra en la pestaña Tiempo de UBS cuando su descarga supera el límite del cliente, y el mismo límite vale para la alerta Descarga por encima del límite. El cliente sin límite queda fuera de la pestaña, y su alerta sigue en 24 horas.',
    'viagens.tempoUbs.limites.busca': 'Buscar cliente',
    'viagens.tempoUbs.limites.cliente': 'Cliente',
    'viagens.tempoUbs.limites.limite': 'Tiempo límite',
    'viagens.tempoUbs.limites.nenhum': 'Ningún cliente con ese nombre',
    'viagens.tempoUbs.limites.horasDe': 'Horas del límite de {{cliente}}',
    'viagens.tempoUbs.limites.minutosDe': 'Minutos del límite de {{cliente}}',
    'viagens.tempoUbs.limites.invalido': 'Revise los campos en rojo: el minuto va hasta 59 y el límite hasta 720 horas.',
    'viagens.tempoUbs.limites.salvo': 'Límites guardados',
    'viagens.tempoUbs.limites.erro': 'No fue posible guardar los límites',
    'viagens.relatorio.hintClique': 'Haga clic en el viaje para ver la entrada en cada estado.',
    'viagens.col.contrato': 'Contrato',
    'viagens.contrato.foraDoHub': 'FUERA DEL HUB',
    'viagens.contrato.outrosServicos': 'OTROS SERVICIOS',
    'viagens.contrato.outrosServicosDica': 'Viaje registrado en el módulo Otros Servicios de Transporte.',
    'viagens.contrato.transporteMaquina': 'TRANSPORTE DE MÁQUINA',
    'viagens.contrato.transporteMaquinaDica': 'Viaje vinculado en Transporte de Máquina, en una línea sin contrato y sin lugar de destino.',
    'viagens.contrato.cancelada': 'CANCELADO',
    'viagens.contrato.canceladaDica': 'Viaje cancelado en el ERP. No cuenta en los totales del Dashboard.',
    'viagens.contrato.erp': 'En el ERP: {{contrato}}',
    'viagens.contrato.semErp': 'Sin vínculo con un contrato del HUB y sin contrato en el ERP.',
    'viagens.contrato.destinoPrancha': 'Contrato destino',
    'viagens.contrato.garagem': 'Garaje de destino',
    'viagens.km.fonteViagem': 'KM Total del viaje en Protheus.',
    'viagens.km.fonteSubcontrato': 'Distancia del subcontrato. Protheus todavía no envía el KM del viaje.',
    'viagens.servico.apontado': 'Servicio asignado',
    'viagens.servico.apontar': 'Asignar servicio',
    'viagens.servico.trocarApontado': 'Cambiar servicio asignado',
    'viagens.lapis.editar': 'Corregir viaje',
    'viagens.lapis.ajustado': 'Corregido por {{quem}} el {{quando}}',
    'viagens.lapis.suspenso': 'Corrección suspendida: la carga o el ciclo cambió después de ella. Vale la medida del HUB hasta que alguien corrija de nuevo.',
    'viagens.lapis.alguem': 'alguien',
    'viagens.status.adiantando': 'Adelantando',
    'viagens.status.escalado': 'Programado',
    'viagens.status.carregando': 'Cargando',
    'viagens.status.transito': 'Tránsito',
    'viagens.status.descarregando': 'Descargando',
    'viagens.status.disponivel': 'Disponible',
    'viagens.detalhe.titulo': 'Viaje',
    'viagens.detalhe.corrigir': 'Corregir',
    'viagens.detalhe.status': 'Entrada en cada estado',
    'viagens.detalhe.corrigido': 'Corregido',
    'viagens.detalhe.medido': 'Medido por el HUB: {{quando}}',
    'viagens.detalhe.semMedida': 'Sin medida del HUB',
    'viagens.detalhe.semMedidaCurta': 'Sin medida',
    'viagens.detalhe.semRegistro': 'Sin registro',
    'viagens.detalhe.descarga': 'Descarga',
    'viagens.detalhe.inicioDescarga': 'Inicio de la descarga',
    'viagens.detalhe.fimDescarga': 'Fin de la descarga',
    'viagens.detalhe.tempoDescarga': 'Tiempo de descarga',
    'viagens.detalhe.tempoTransito': 'Tiempo de tránsito',
    'viagens.detalhe.km': 'Kilometraje',
    'viagens.detalhe.edicoes_one': '{{count}} corrección en este viaje',
    'viagens.detalhe.edicoes_other': '{{count}} correcciones en este viaje',
    'viagens.ajuste.explica': 'Corrija solo lo que esté mal. La corrección vale en el módulo de Viajes; el Panel de Descarga y la Jornada siguen con lo que la operación registró.',
    'viagens.ajuste.travados': 'No editables',
    'viagens.ajuste.medidoHub': 'Medido por el HUB: {{quando}}',
    'viagens.ajuste.semMedidaHub': 'Sin medida del HUB',
    'viagens.ajuste.voltarAoMedido': 'Volver a lo medido',
    'viagens.ajuste.recalculo': 'Con la corrección',
    'viagens.ajuste.depara': 'de {{de}} a {{para}}',
    'viagens.ajuste.nadaMudou': 'Nada cambió. Modifique un campo antes de guardar.',
    'viagens.ajuste.dataInvalida': 'Fecha y hora inválida.',
    'viagens.ajuste.futuro': 'La fecha y hora no puede estar en el futuro.',
    'viagens.ajuste.ordem': '{{depois}} debe ser después de {{antes}}.',
    'viagens.ajuste.kmInvalido': 'El kilometraje debe estar entre 0 y 5000 km.',
    'viagens.ajuste.salvo': 'Viaje corregido. Tiempos, optimización y alertas recalculados.',
    'viagens.apontar.titulo': 'Asignar servicio',
    'viagens.apontar.original': 'Servicio original',
    'viagens.apontar.escolha': 'Servicio correcto',
    'viagens.apontar.dica': 'Los Otros Servicios del registro de Servicios. No van a Protheus.',
    'viagens.apontar.semInternos': 'Ningún Otro Servicio registrado todavía.',
    'viagens.apontar.remover': 'Quitar asignación',
    'viagens.apontar.salvo': 'Servicio asignado.',
    'viagens.apontar.removido': 'Asignación retirada.',
    'viagens.dash.viagensPorCliente': 'Viajes por cliente',
    'viagens.dash.kmTotalPorCliente': 'KM total por cliente',
    'viagens.dash.kmMedioPorCliente': 'KM promedio por cliente',
    'viagens.dash.pesoTotalPorCliente': 'Peso total por cliente en Mazorca',
    'viagens.dash.pesoMedioPorCliente': 'Peso promedio por cliente en Mazorca',
    'viagens.dash.otimizacaoEspiga': 'Optimización de KM en Mazorca',
    'viagens.dash.viagensPorDiaEspiga': 'Viajes de Mazorca por día',
    'viagens.dash.viagensPorDiaHint': 'Filas del Frente de Trabajo, por la fecha de la carga. De abajo hacia arriba, atendidos, en curso en los demás estados y no atendidos.',
    'viagens.dash.viagensPorDestinoEspiga': 'Viajes de Mazorca por destino',
    'viagens.dash.descargaPorDestinoEspiga': 'Descarga promedio de Mazorca por destino',
    'viagens.dash.viagensPorDupla': 'Viajes por dupla',
    'viagens.dash.viagensPorDestino': 'Viajes por destino',
    'viagens.dash.semKm': 'Ningún viaje con KM Protheus en el recorte.',
    'viagens.dash.semPeso': 'Protheus todavía no envía el peso de los viajes.',
    'viagens.dash.tabelaPlacas': 'Por placa',
    'viagens.dash.tabelaMotoristas': 'Por conductor',
    'viagens.dash.tabelaHint': 'KM sin programación y KM vacío medidos por GPS, KM recibido por Protheus. Los servicios cuentan los viajes por el servicio final. La optimización suma solo los viajes que tienen el vacío y el recibido. Haga clic en el encabezado para ordenar.',
    'viagens.dash.col.base': 'Base',
    'viagens.dash.col.kmVazio': 'KM vacío',
    'viagens.dash.col.kmRecebido': 'KM recibido',
    'viagens.dash.col.peso': 'Peso',
    'viagens.alertas.count_one': '{{count}} alerta',
    'viagens.alertas.count_other': '{{count}} alertas',
    'viagens.alertas.hint': 'Haga clic en la fila para abrir el viaje y corregirlo con el lápiz. La alerta corregida se cierra sola.',
    'viagens.alertas.vazio': 'Ninguna alerta en este recorte.',
    'viagens.alertas.col.tipo': 'Tipo de alerta',
    'viagens.alertas.col.statusProtheus': 'Estado en Protheus',
    'viagens.alertas.col.filial': 'Filial',
    'viagens.alertas.col.status': 'Estado de la alerta',
    'viagens.alertas.filtro.status': 'Estado de la alerta',
    'viagens.alertas.filtro.tipo': 'Tipo de alerta',
    'viagens.alertas.status.pendente': 'Pendiente',
    'viagens.alertas.status.corrigido': 'Corregido',
    'viagens.alertas.status.justificado': 'Justificado',
    'viagens.alertas.tipo.otimizacao': 'Optimización fuera del límite',
    'viagens.alertas.tipo.descarga_curta': 'Descarga debajo del límite',
    'viagens.alertas.tipo.descarga_longa': 'Descarga encima del límite',
    'viagens.alertas.tipo.transito_longo': 'Tránsito encima de lo esperado',
    'viagens.alertas.tipo.transito_curto': 'Tránsito debajo de lo esperado',
    'viagens.alertas.tipo.km_baixo': 'KM bajo fuera de Mazorca',
    'viagens.alertas.regra.otimizacao': 'Optimización encima de +10% o debajo de −10%.',
    'viagens.alertas.regra.descarga_curta': 'Descarga con menos de 4 horas.',
    'viagens.alertas.regra.descarga_longa': 'Descarga con más de 24 horas, el límite general para el cliente sin límite propio.',
    'viagens.alertas.regra.descarga_longa_cliente': 'Descarga por encima del límite del cliente, de {{limite}}.',
    'viagens.alertas.regra.transito_longo': 'Tránsito encima de {{limite}}, que es 1 hora cada 50 km del KM Protheus más 1 hora de comida.',
    'viagens.alertas.regra.transito_curto': 'Tránsito debajo de {{limite}}, que es 30 minutos cada 50 km del KM Protheus más 1 hora de comida.',
    'viagens.alertas.regra.km_baixo': 'Viaje que no es Mazorca ni Viático con KM Protheus debajo de 10 km.',
    'viagens.alertas.regra.semKm': 'El viaje no tiene KM Protheus ahora, y la franja de tránsito no se calcula.',
    'viagens.alertas.justificar': 'Justificar',
    'viagens.alertas.editarJustificativa': 'Editar',
    'viagens.alertas.justificarTitulo': 'Justificar alerta',
    'viagens.alertas.ajudaJustificativa': 'Obligatoria. Diga por qué el viaje queda como está.',
    'viagens.alertas.justificado': 'Alerta justificada',
    'viagens.alertas.quemQuando': '{{quem}}, {{quando}}',
    'viagens.alertas.corrigidoPorAjuste': 'Corregida con el lápiz el {{quando}}',
    'viagens.alertas.corrigidoPelaMedida': 'Corregida por la medida el {{quando}}',
    'viagens.alertas.antes': 'Antes',
    'viagens.col.kmVazioContrato': 'KM vacío contrato',
    'viagens.km.vazioContratoDica': 'El KM del registro del contrato. Es el KM vacío esperado del viaje, comparado con el KM vacío medido por el HUB.',
    'viagens.km.vazioContratoSem': 'Contrato sin KM en el registro, o viaje fuera del HUB o de plataforma.',
    'viagens.nf.dentroDaTolerancia': 'Solicitada {{atraso}} después de la entrada en Tránsito, dentro del plazo de {{prazo}}.',
    'viagens.nf.foraDoPrazo': 'Solicitada {{atraso}} después de la entrada en Tránsito, fuera del plazo de {{prazo}}.',
    'viagens.nf.emissao.dentroDaTolerancia': 'Confirmada {{atraso}} después de la entrada en Tránsito, dentro del plazo de {{prazo}}.',
    'viagens.nf.emissao.foraDoPrazo': 'Confirmada {{atraso}} después de la entrada en Tránsito, fuera del plazo de {{prazo}}.',
    'viagens.detalhe.nf': 'Solicitud de NF',
    'viagens.detalhe.nfSolicitada': 'Solicitada el',
    'viagens.detalhe.nfEmissao': 'Emisión NF',
    'viagens.detalhe.nfConfirmada': 'Confirmada el',
    'viagens.detalhe.nfAtraso': 'Después del Tránsito',
    'viagens.ajuste.nfDepois': 'Solicitud de NF después del Tránsito',
    'viagens.ajuste.nfEmissaoDepois': 'Emisión NF después del Tránsito',
    'viagens.alertas.tipo.nf_atrasada': 'Solicitud de NF fuera de plazo',
    'viagens.alertas.regra.nf_atrasada': 'NF solicitada más de 30 minutos después de la entrada en Tránsito. Corregir la entrada en Tránsito con el lápiz recalcula la Solicitud de NF.',
    'viagens.dash.ind.viagens': 'Total de viajes',
    'viagens.dash.ind.viagensHint': 'Según los filtros',
    'viagens.dash.ind.kmTotal': 'Total de KM',
    'viagens.dash.ind.kmMedio': 'Promedio de KM',
    'viagens.dash.ind.kmHint': 'Mazorca, por el KM Protheus',
    'viagens.dash.ind.peso': 'Peso total transportado',
    'viagens.dash.ind.pesoMedio': 'Promedio de peso',
    'viagens.dash.ind.pesoHint': 'Mazorca, en toneladas',
    'viagens.dash.ind.nf': 'Solicitud de NF',
    'viagens.dash.ind.nfTime': 'Equipo de logística',
    'viagens.dash.ind.nfEmissao': 'Emisión NF',
    'viagens.dash.ind.nfEmissaoTime': 'Equipo de notas',
    'viagens.dash.ind.nfEmissaoHint_one': 'Plazo de {{prazo}} desde la entrada en Tránsito hasta la confirmación. {{count}} nota medida.',
    'viagens.dash.ind.nfEmissaoHint_other': 'Plazo de {{prazo}} desde la entrada en Tránsito hasta la confirmación. {{count}} notas medidas.',
    'viagens.dash.ind.nfDentro': 'Dentro del plazo',
    'viagens.dash.ind.nfFora': 'Fuera del plazo',
    'viagens.dash.ind.nfAtraso': 'Atraso promedio',
    'viagens.dash.ind.nfHint_one': 'Plazo de {{prazo}} después de la entrada en Tránsito. {{count}} nota medida.',
    'viagens.dash.ind.nfHint_other': 'Plazo de {{prazo}} después de la entrada en Tránsito. {{count}} notas medidas.',
    'viagens.dash.motivos': 'Motivos de no atención',
    'viagens.dash.motivos.col.motivo': 'Motivo',
    'viagens.dash.motivos.col.cargas': 'Cargas',
    'viagens.dash.motivos.col.pct': 'De las no atendidas',
    'viagens.dash.motivos.vazio': 'Ninguna carga de mazorca no atendida en este rango.',
    'viagens.dash.motivos.hint_one': '{{count}} carga de mazorca no atendida.',
    'viagens.dash.motivos.hint_other': '{{count}} cargas de mazorca no atendidas.',
    'viagens.dash.col.modalidade': 'Modalidad',
    'viagens.dash.grupo.servicos': 'Viajes por servicio',
    'viagens.dash.grupo.km': 'Kilometraje',
  },
}
